module.exports = __webpack_public_path__ + "static/ignite-e906f59880d2eff0e773a812267d54e0.jpg";